// extracted by mini-css-extract-plugin
export default {"advertFooter":"hw6ctG0r"};